import {device} from '@guestapp/ui/src/utils/device';
import ModalSheet from 'components/common/ModalSheet';
import styled from 'styled-components';

export const ContentInformationBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 4px;
  margin: 0 auto 72px;

  & div:first-child {
    position: relative;
    top: 2px;
  }

  @media (min-width: ${device.tablet}) {
    max-width: 320px;
    margin: 0 auto 48px;
  }

  path,
  circle {
    stroke: ${props => props.theme.colors.branding.fontSecondary};
  }
`;

export const EditIconWrapper = styled.div`
  cursor: pointer;
  path,
  rect {
    fill: ${props => props.theme.colors.branding.primary};
  }
`;

export const GuestListTitle = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 24px;
  text-align: center;
  display: flex;
  gap: 8px;
  font-family: ${props => props.theme.fonts.fontFamily.titles.font_name};
  color: ${props => props.theme.colors.branding.fontPrimary};

  @media (min-width: ${device.tablet}) {
    margin-bottom: 32px;
  }
`;

export const SubTitleInformation = styled.div`
  font-style: normal;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  color: ${props => props.theme.colors.branding.fontSecondary};

  @media (min-width: ${device.tablet}) {
    width: 100%;
    text-align: center;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const StyledIncompleteGuestsModal = styled(ModalSheet)`
  &-overlay {
    overflow: hidden;
  }

  &-content {
    @media (min-width: ${device.mobileL}) {
      max-width: 375px;
      padding-top: 60px;
      & .chekin-button_link {
        margin-bottom: 0;
      }
    }
  }
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 220px;
`;
